import { Box, Flex, formatPostalCode, Headings, Text } from '@foradevelopment/fora-ui';

import { useAppSelector } from '../../redux/hooks';
import { useTypedTranslation } from '../../i18n/i18n';

export const AddressDetails = ({
  title,
  streetAddress,
  streetAddress2,
  coAddress,
  city,
  postalCode,
  country,
  singleRow,
}: {
  title?: string;
  streetAddress: string;
  streetAddress2?: string;
  coAddress?: string;
  city: string;
  postalCode?: string;
  country: string;
  singleRow?: boolean;
}) => {
  const ffManageEmployeeAndEmployment = useAppSelector(
    state => state.foraGlobal.settings.ffManageEmployeeAndEmployment
  );
  const { t } = useTypedTranslation();

  return ffManageEmployeeAndEmployment && singleRow ? (
    <Box>
      <Text size="small" color="black70">
        {t('common.address')}
      </Text>
      <Flex flexWrap="wrap">
        {coAddress && <Text>{`${coAddress},`}&nbsp;</Text>}
        <Text>{`${streetAddress},`}&nbsp; </Text>
        {streetAddress2 && <Text>{`${streetAddress2},`}&nbsp;</Text>}
        <Text>
          {postalCode && formatPostalCode(postalCode)} {city},&nbsp;
        </Text>

        <Text> {country}</Text>
      </Flex>
    </Box>
  ) : ffManageEmployeeAndEmployment && !singleRow ? (
    <>
      <Text marginBottom={6} marginTop={30} size="small" color="black70">
        {t('common.address')}
      </Text>
      {coAddress && <Text marginBottom={10}>{coAddress}</Text>}
      <Text marginBottom={10}>{streetAddress}</Text>
      {streetAddress2 && <Text marginBottom={10}>{streetAddress2}</Text>}
      <Text marginBottom={10}>
        {postalCode && formatPostalCode(postalCode)} {city}
      </Text>
      <Text marginBottom={10}>{country}</Text>
    </>
  ) : (
    // TODO: 172231 Remove below this comment
    <>
      {title && <Headings.H5 marginBottom={6}>{title}</Headings.H5>}
      {coAddress && (
        <Text color="black70" fontWeight="semibold">
          {coAddress}
        </Text>
      )}
      <Text color="black70" fontWeight="semibold">
        {streetAddress}
      </Text>
      {streetAddress2 && (
        <Text color="black70" fontWeight="semibold">
          {streetAddress2}
        </Text>
      )}
      <Text color="black70">
        {postalCode} {city}
      </Text>
      <Text color="black70">{country}</Text>
    </>
  );
};
